export const EDITAR_ACTION = 'EDITAR';
export const REGISTRAR_ACTION = 'REGISTRAR';
export const UNDEFINED_ACTION = 'UNDEFINED'
